import {computed, ComputedRef, Ref, ref} from "vue";

/**
 * The answering of a Girerd questionnaire, shared by the scenes that ask
 * it: the answers given so far by question ref, local until the closing
 * action submits them all, and the questions still without one.
 *
 * What an answer holds belongs to each questionnaire: the collection lets a
 * « yes » name treatments, the follow-up answers yes or no alone.
 */
export function useGirerdAnswers<TAnswer>(questions: ComputedRef<Array<{ref: string}>>) {
    const answers = ref({}) as Ref<Record<string, TAnswer>>;

    /**
     * The refs of the questions still unanswered, in order.
     */
    const missing = computed(() => questions.value
        .filter(question => !(question.ref in answers.value))
        .map(question => question.ref));

    /**
     * Answer one question — local only: the closing action submits them all.
     */
    const answer = (questionRef: string, given: TAnswer) => {
        answers.value = {...answers.value, [questionRef]: given};
    };

    return {answers, missing, answer};
}
